export default __webpack_public_path__ + "722c114a6317844b5a438346da5c2ace.wasm";